<template>
    <div id="appIndex">
        <loadingS v-if='loading'></loadingS>
        <template v-else>
            <div class="appIndex_banner">
                <div class="back_icon"
                     @click="goBack">
                </div>
            </div>
            <div class="list">
                <div class="item"
                     v-for="(item,index) in sx_paper"
                     :key="index">
                    <div class="title">
                        <p>{{gradeList[item.grade_id]}}数学期末套卷</p>
                    </div>
                    <div class="con">
                        <div class="main">
                            <div class="paper-list">
                                <div class="paper-item"
                                     v-for="(item2,index2) in item.object_list"
                                     :key="index2">
                                    <div class="paper-name">
                                        <p>{{item2.paper_name }}</p>
                                    </div>
                                    <div class="btn-list">
                                        <div class="btn-item"
                                             @click="preview(item2)">
                                            <span><img src="./img/icon_preview.png"
                                                     alt=" " /></span>
                                            <p>试卷预览</p>
                                        </div>
                                        <div class="btn-item"
                                             @click="share(item2)">
                                            <span><img src="./img/icon_stu.png"
                                                     alt=" " /></span>
                                            <p>分享给学生</p>
                                        </div>
                                        <div class="btn-item"
                                             @click="view(item2)">
                                            <span><img src="./img/icon_info.png"
                                                     alt=" " /></span>
                                            <p>查看完成情况</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item"
                     v-for="(item,index) in yw_paper"
                     :key="index+100">
                    <div class="title">
                        <p>{{ gradeList[item.grade_id] }}语文期末套卷</p>
                    </div>
                    <div class="con">
                        <div class="main">
                            <div class="paper-list">
                                <div class="paper-item"
                                     v-for="(item2, index2) in item.object_list"
                                     :key="index2">
                                    <div class="paper-name">
                                        <p>{{ item2.paper_name }}</p>
                                    </div>
                                    <div class="btn-list">
                                        <div class="btn-item"
                                             @click="preview(item2)">
                                            <span><img src="./img/icon_preview.png"
                                                     alt=" " /></span>
                                            <p>试卷预览</p>
                                        </div>
                                        <div class="btn-item"
                                             @click="share(item2)">
                                            <span><img src="./img/icon_stu.png"
                                                     alt=" " /></span>
                                            <p>分享给学生</p>
                                        </div>
                                        <div class="btn-item"
                                             @click="view(item2)">
                                            <span><img src="./img/icon_info.png"
                                                     alt=" " /></span>
                                            <p>查看完成情况</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="doinfo"
                 v-if="showUnitList">
                <div class="main">
                    <img src="./img/icon_close.png"
                         class="close"
                         @click="close" />
                    <strong>查看完成情况</strong>
                    <p>-请选择您要查看的班级-</p>
                    <span class="unit"
                          v-for="(item,index) in class_info.class_list"
                          :key="index"
                          @click="goDetail(item)">{{item.unit_name }}</span>
                </div>
            </div>
            <div class="doinfo"
                 v-if="showShare">
                <div class="main">
                    <strong>分享链接复制成功</strong>
                    <p class="tips">在输入框中进行粘贴后<br>点击发送即可！</p>
                    <span class="btn"
                          @click="close">确定</span>
                </div>
            </div>
        </template>
    </div>
</template>
<script type="text/ecmascript-6">
import loadingS from 'SRC/components/base/loadingS.vue';
export default {
    components: {
        loadingS
    },
    data () {
        return {
            hd_type: 7,//本次活动type
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            loading: true,
            class_info: [],
            showUnitList: false,
            showShare: false,
            gradeList: ['', '一年级', '二年级', '三年级', '四年级', '五年级', '六年级', '七年级', '八年级', '九年级'],
            sx_paper: [],
            yw_paper: [],
        }
    },
    created () {
        //修改页面标题
        window.document.title = "期末综合测评"
        this.$http.get(API_URL_HD_API + "/qm2023/paper").then(res => {
            res = res.data;
            if (res.response === 'ok') {
                this.sx_paper = res.data.sx_paper
                this.yw_paper = res.data.yw_paper

            } else {
                layer.tips(res.message);
            }
        }).finally(() => { this.loading = false; })
    },
    methods: {
        goBack () {
            this.appFunction("ys_finish", "", 1);
        },
        preview (item) {
            let url = ""
            if (item.sid == 51) {
                url = '/chinese/inspect/preview/task/' + item.paper_id + '?hd_type=' + this.hd_type
            } else {
                url = '/preview/task/21/' + item.paper_id + '?hd_type=' + this.hd_type
            }
            if (url) {
                this.$router.push(url)
            }
        },
        more () {
            this.$router.push('/activity/2023qmjc/gold')
        },
        share (item) {
            if (this.inApp) {
                let title = item.school_name + (item.sid == 21 ? "数学" : "语文") + "期末综合测评";
                let content = "点击参加" + (item.sid == 21 ? "数学" : "语文") + "期末综合测评";
                this.appFunction("ys_share", `${title},${content},${item.wap_url},${String(item.sid)[0]},${item.class_list[0].unit_class_id},0,26,期末综合测评活动分享`);
            } else {
                let subject = item.sid == 21 ? '数学' : item.sid == 51 ? '语文' : ''
                let coptText = `${item.school_name}${subject}期末综合测评，点击链接参加${subject}期末综合测评，链接：${item.wap_url}`
                this.copyText(coptText);
                this.showShare = true
            }

        },
        view (item) {
            if (item.class_list.length > 1) {
                this.class_info = item
                this.showUnitList = true
            } else {

                this.$store.commit('setTabtype', 1)
                let dept_type = item.grade_id < 7 ? 1 : 2
                this.$router.push(`/personaLearning?sid=${item.sid == 51 ? 51 : 21}&taskId=${item.paper_id}&classId=${item.class_list[0].unit_class_id}&hd_type=${this.hd_type}&dept_type=${dept_type}&className=${encodeURIComponent(item.class_list[0].unit_name)}`)
            }
        },
        close () {
            this.showShare = false
            this.showUnitList = false
        },
        goDetail (item) {
            let dept_type = this.class_info.grade_id < 7 ? 1 : 2
            this.$store.commit('setTabtype', 1)
            this.$router.push(`/personaLearning?sid=${item.sid == 51 ? 51 : 21}&taskId=${this.class_info.paper_id}&classId=${item.unit_class_id}&hd_type=${this.hd_type}&dept_type=${dept_type}&className=${encodeURIComponent(item.unit_name)}`)
        },
        copyText (text) {
            const input = document.createElement('input');
            input.setAttribute('readonly', 'readonly');
            input.setAttribute('value', text);
            document.body.appendChild(input);
            input.setSelectionRange(0, 9999);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        },
    },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
#appIndex {
    width: 720px / $ppr;
    overflow: hidden;
    min-height: 820px;
    background-color: #c0e0ff;
    .appIndex_banner {
        height: 820px / $ppr;
        background-size: 100% 100%;
        background-image: url("./img/index-bg.jpg");
        position: relative;
        .back_icon {
            position: absolute;
            width: 64px / $ppr;
            height: 96px / $ppr;
            background-position: center;
            background-size: 20px / $ppr 34px / $ppr;
            background-repeat: no-repeat;
            background-image: url("./img/img_icon_01.png");
            cursor: pointer;
        }
    }
    .list {
        position: relative;
        margin-top: -69px / $ppr;
        .item {
            background: #cee7ff;
            border-top-right-radius: 100px / $ppr;
            border-top: 2px / $ppr solid #ebf3fd;
            border-right: 2px / $ppr solid #ebf3fd;
            margin-right: -2px / $ppr;
            .title {
                p {
                    display: inline-block;
                    background-image: linear-gradient(to top, #2f4eec, #0590f0);
                    -webkit-background-clip: text;
                    color: transparent;
                    font-size: 46px / $ppr;
                    font-weight: bold;
                    position: relative;
                    top: 8px / $ppr;
                }
                &:before {
                    content: "";
                    display: inline-block;
                    vertical-align: middle;
                    width: 20px / $ppr;
                    height: 114px / $ppr;
                    border-radius: 0 10px / $ppr 10px / $ppr 0;
                    background-color: #2e4deb;
                    background: -webkit-linear-gradient(
                        bottom,
                        #2e4deb 0%,
                        #00a3ff 100%
                    );
                    margin-right: 20px / $ppr;
                }
                &:after {
                    content: "";
                    display: inline-block;
                    vertical-align: middle;
                    width: 39px / $ppr;
                    height: 29px / $ppr;
                    background: url("./img/title-after.png") no-repeat;
                    background-size: 39px / $ppr 29px / $ppr;
                    margin-left: 20px / $ppr;
                }
            }
            .con {
                background: #c0e0ff;
                background: -webkit-linear-gradient(
                    top,
                    #c0e0ff 0%,
                    #bfdfff 100%
                );
                border-top-right-radius: 100px / $ppr;
                padding: 56px / $ppr 36px / $ppr;
                .main {
                    border-radius: 30px / $ppr 100px / $ppr 30px / $ppr 30px /
                        $ppr;
                    background-color: #f1f7ff;
                    background: -webkit-linear-gradient(
                        top,
                        #f1f7ff 0%,
                        #d0e7ff 100%
                    );
                    box-shadow: 0px 8px / $ppr 54px / $ppr 20px / $ppr
                        rgba(47, 79, 236, 0.08);
                    -webkit-box-shadow: 0px 8px / $ppr 54px / $ppr 20px / $ppr
                        rgba(47, 79, 236, 0.08);
                    .award {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        padding: 78px / $ppr 58px / $ppr 28px / $ppr;
                        img {
                            width: 498px / $ppr;
                            height: 195px / $ppr;
                        }
                        .more {
                            margin-top: 78px / $ppr;
                            width: 540px / $ppr;
                            height: 119px / $ppr;
                        }
                    }
                    .paper-list {
                        .paper-item {
                            padding: 36px / $ppr 4px / $ppr 13px / $ppr;
                            &:last-child {
                                .btn-list {
                                    border-bottom: 0;
                                }
                            }
                            .paper-name {
                                display: inline-block;
                                background-color: #009fff;
                                background: -webkit-linear-gradient(
                                    top,
                                    #009fff 0%,
                                    #2f4eec 100%
                                );
                                border-radius: 0 58px / $ppr 58px / $ppr 0;
                                padding: 0 30px / $ppr 0 20px / $ppr;
                                box-shadow: 0px 8px / $ppr 10px / $ppr
                                    rgba(49, 82, 236, 0.15);
                                -webkit-box-shadow: 0px 8px / $ppr 10px / $ppr
                                    rgba(49, 82, 236, 0.15);
                                p {
                                    background-image: linear-gradient(
                                        to top,
                                        #f6fbff,
                                        #d3e8ff
                                    );
                                    -webkit-background-clip: text;
                                    color: transparent;
                                    font-size: 30px / $ppr;
                                    font-weight: bold;
                                    height: 58px / $ppr;
                                    line-height: 58px / $ppr;
                                }
                            }
                            .btn-list {
                                margin: 50px / $ppr 30px / $ppr 0 30px / $ppr;
                                padding-bottom: 36px / $ppr;
                                border-bottom: 1px dashed #d3e2fd;
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                .btn-item {
                                    display: flex;
                                    flex-direction: column;
                                    align-items: center;
                                    span {
                                        width: 120px / $ppr;
                                        height: 120px / $ppr;
                                        margin-bottom: 17px / $ppr;
                                        background-color: #c6e6ff;
                                        background: -webkit-linear-gradient(
                                            top,
                                            #c6e6ff 0%,
                                            #c8dafd 100%
                                        );
                                        border-radius: 100%;
                                        img {
                                            width: 73px / $ppr;
                                            height: 73px / $ppr;
                                            margin: 23px / $ppr;
                                        }
                                    }
                                    p {
                                        font-size: 24px / $ppr;
                                        color: #333;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    .doinfo {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        .main {
            width: 78%;
            position: absolute;
            left: 11%;
            right: 11%;
            top: 50%;
            transform: translateY(-50%);
            background: #fff;
            border-radius: 38px / $ppr;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 50px / $ppr 62px / $ppr 60px / $ppr;
            box-sizing: border-box;
            &:before {
                content: "";
                position: absolute;
                z-index: -1;
                top: 0;
                left: 0;
                right: 0;
                height: 100px / $ppr;
                border-radius: 38px / $ppr 38px / $ppr 0 0;
                background-color: #cbe8ff;
                background: -webkit-linear-gradient(top, #cbe8ff 0%, #fff 100%);
            }
            .close {
                position: absolute;
                right: 0;
                top: -79px / $ppr;
                width: 49px / $ppr;
                height: 49px / $ppr;
            }
            strong {
                font-size: 40px / $ppr;
                color: #333;
                font-weight: bold;
            }
            p {
                font-size: 28px / $ppr;
                color: #666;
                margin: 15px / $ppr 0 30px / $ppr;
            }
            .unit {
                display: inline-block;
                width: 100%;
                height: 80px / $ppr;
                line-height: 80px / $ppr;
                border-radius: 80px / $ppr;
                margin-top: 26px / $ppr;
                background: #dfefff;
                color: #00a2ff;
                font-size: 32px / $ppr;
                font-weight: bold;
                text-align: center;
            }
            .tips {
                font-size: 30px / $ppr;
                color: #333;
                text-align: center;
                margin: 35px / $ppr 0 45px / $ppr;
                line-height: 1.7;
            }
            .btn {
                padding: 0 112px / $ppr;
                display: inline-block;
                height: 72px / $ppr;
                line-height: 72px / $ppr;
                border-radius: 72px / $ppr;
                font-size: 34px / $ppr;
                font-weight: bold;
                color: #fff;
                background-color: #009fff;
                background: -webkit-linear-gradient(
                    left,
                    #009fff 0%,
                    #2f4eec 100%
                );
            }
        }
    }
}
</style>